import { useEffect, useMemo, useState } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import gridColumns from "helpers/gridColumns";
import { IconButton, Tooltip } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

const GrillaEffect = ({
  data,
  updateData,
  filters,
  updateFilters,
  hiddenColumns = null,
  customTopToolbar = null,
  idRemoto = null,
  baseURI = null,
  method = 'POST',
  colsHeaders = [],
  useCustomFilter = false,
  displayColumnDefOptions,
  handleRevertir,
  handleConciliar,
  onRowSelectionChange,
  isLoading: isLoadingProp,
  // NUEVO: Agregar prop para parámetros adicionales
  additionalParams = {},
  rowSelectionEnabled = false,
}) => {
  //data and fetching state
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  //table state
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [columnOrder, setColumnOrder] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const fetchData = async () => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    let currentFilters = [...filters];
    currentFilters = currentFilters.filter(filter => {
      return Object.keys(colsHeaders).some(columnKey => columnKey === filter.id)
    });
    const baseURL = baseURI ? baseURI : `${process.env.REACT_APP_API_URL}/querysextgrilla/`;
    console.log("BaseURL en GrillaEffect: ", baseURL);
    // Objeto con los parámetros que deseas enviar                   
    const queryParams = {
      id: idRemoto ? idRemoto : 21,
      page: pagination.pageIndex,
      size: pagination.pageSize,
      filters: JSON.stringify(currentFilters ?? []),
      globalFilter: globalFilter ?? '',
      sorting: JSON.stringify(sorting ?? []),
      custom_filter: useCustomFilter,
      // NUEVO: Agregar parámetros adicionales
      ...additionalParams
    };
    const urlWithParams = new URL(baseURL);
    Object.keys(queryParams).forEach(key => urlWithParams.searchParams.append(key, queryParams[key]));

      try {
        const response = await fetch(urlWithParams, {
          method: method,
          headers: {
            "Content-Type": "application/json",
            "Authorization": localStorage.getItem('token'),
          }
        });
        const json = await response.json();
        updateData(json.data);
        if(json.meta.totalRowCount !== undefined){
          setRowCount(json.meta.totalRowCount);
        }
      } catch (error) {
        setIsError(true);
        console.error(error);
        return;
      }
      setIsError(false);
      setIsLoading(false);
      setIsRefetching(false);
    };
  useEffect(() => {
    fetchData();
  }, [
    filters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    // CAMBIO: Usar JSON.stringify para comparar correctamente el objeto
    JSON.stringify(additionalParams),
  ]);
  const refreshIconComponent = function () {
    return <Tooltip arrow title="Actualiza Tabla">
      <IconButton onClick={() => fetchData()}>
        <RefreshIcon />
      </IconButton>
    </Tooltip>
  };
  const columns = gridColumns(data, colsHeaders, filters, handleRevertir, handleConciliar);
  const table = useMaterialReactTable({
    columns,
    data,
    enableFilters: true,
    enableColumnFilters: true,
    enableRowSelection: rowSelectionEnabled,
    onRowSelectionChange: (updater) => {
      setRowSelection(updater);
      if (onRowSelectionChange) {
        onRowSelectionChange(
          typeof updater === 'function' ? updater(rowSelection) : updater,
          table
        );
      }
    },
    state: {
      filters,
      globalFilter,
      isLoading: isLoadingProp ?? isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
      rowSelection,
      // CAMBIO: Modificar columnOrder para incluir las columnas de selección al principio
      ...(typeof colsHeaders === 'object' && !Array.isArray(colsHeaders) && {
        columnOrder: ['mrt-row-select', ...Object.keys(colsHeaders)]
      })
    },
    initialState: {
      columnVisibility: hiddenColumns,
      showColumnFilters: true,
      columnFilters: filters,
      // CAMBIO: También en initialState
      ...(typeof colsHeaders === 'object' && !Array.isArray(colsHeaders) && {
        columnOrder: ['mrt-row-select', ...Object.keys(colsHeaders)]
      })
    },
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    // CAMBIO: Agregar configuración adicional para el ordenamiento
    enableSorting: true,
    enableMultiSort: true,
    muiTableBodyProps: {
      children: isLoading ? (
        <tr style={{ height: '200px' }}>
          <td />
        </tr>
      ) : undefined,
    },
    muiToolbarAlertBannerProps: isError
      ? {
        color: 'error',
        children: 'Error loading data',
      }
      : undefined,
    onColumnFiltersChange: updateFilters,
    onColumnOrderChange: setColumnOrder,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    renderTopToolbarCustomActions: typeof customTopToolbar === 'function'
      ? customTopToolbar
      : () => (customTopToolbar ?? refreshIconComponent()),
    displayColumnDefOptions,
    rowCount,
  });

  return <MaterialReactTable table={table} />;
}

export default GrillaEffect;